import { PERMITTED_COUNTRIES } from '@/constants/countries';
import { IAddress } from '@/types/interfaces/Profile.interface';

export function composeAddress(address?: IAddress) {
  if (address === undefined) return '';
  const addressArray = [];

  if (address.country) addressArray.push(address.country);
  if (address.city) addressArray.push(address.city);
  if (address.street) addressArray.push(address.street);
  if (address.houseNumber) addressArray.push(address.houseNumber);
  if (address.zipCode) addressArray.push(address.zipCode);

  return addressArray.join(', ');
}

export function composeHumanAddress(address?: IAddress) {
  if (address === undefined) return '';
  const addressArray = [];

  if (address.country) {
    const country = PERMITTED_COUNTRIES.find((el) => el.code === address.country);
    if (country) addressArray.push(country.name);
  }
  if (address.city) addressArray.push(address.city);
  if (address.street) addressArray.push(address.street);
  if (address.houseNumber) addressArray.push(address.houseNumber);
  if (address.zipCode) addressArray.push(address.zipCode);

  return addressArray.join(', ');
}
